import { initializeApp, getApps } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { fbConfig } from '@/utils/constants'

// Initialize Firebase only if not already initialized
const app = getApps().length === 0 ? initializeApp(fbConfig) : getApps()[0]

// Export auth instance
export const auth = getAuth(app)

export default app
